import { ComponentProps } from 'react';

import { Detail } from 'components/drawer';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const ConditionalDetail = ({
  ...props
}: ComponentProps<typeof Detail>) => {
  const { isCastAnywhere } = useCluster();

  if (isCastAnywhere && props.detail === '') {
    return null;
  }

  return <Detail {...props} />;
};
